export const paymentMethods = {
  name: 'Payment Methods',
  edit_title: 'Edit Payment Method',
  fields: {
    search: 'Search',
    code: 'Code',
    name: 'Name',
    type: 'Type',
    gateway: 'Gateway',
    icon_key: 'Icon Key',
    device_type: 'Device Type',
    is_active: 'Active',
    sort_order: 'Sort Order',
    supports_tokenization: 'Savable',
    gateway_method_code: 'Gateway Code',
    display_name: 'Display Name',
    description: 'Description',
    created_at: 'Created At',
    updated_at: 'Updated At',
  },
  types: {
    card: 'Card',
    ewallet: 'E-Wallet',
    mobile_wallet: 'Mobile Wallet',
  },
  device_types: {
    all: 'All Devices',
    ios: 'iOS Only',
    android: 'Android Only',
  },
  sections: {
    basic_settings: 'Basic Settings',
    gateway_settings: 'Gateway Settings',
    translations: 'Translations',
    read_only: 'Read-Only Information',
  },
  hints: {
    drag_to_reorder: 'Drag to reorder',
    is_active: 'When disabled, this payment method will not appear in the app',
    sort_order: 'Lower numbers appear first in the app',
    icon_key: 'Icon identifier used by the mobile app',
    gateway: 'Select which payment gateway processes this method',
    edit_info: 'Modify payment method settings. Changes take effect immediately in the app.',
  },
};

export const paymentMethodsResource = {
  ...paymentMethods,
};
